import { Button, Grid, LinearProgress, Typography } from "@material-ui/core";
import AddIcon from "@material-ui/icons/Add";
import AssignmentIndIcon from "@material-ui/icons/AssignmentInd";
import * as React from "react";
import { FC, useState } from "react";
import { useHistory } from "react-router-dom";
import { routesPaths } from "../../../Routes";
import { useGetMyModulesAndExamsForCandidateQuery } from "../../../api/rtk/MeApi";
import TranslatedMessage from "../../translations/TranslatedMessage";
import HomeSection from "../HomeSection";
import MyExamsTable from "./MyExamsTable";
import SelfCancelDialog from "./SelfCancelDialog";
import { CandidateMyModuleViewModel } from "../../../model/me/CandidateMyModuleViewModel";
import { useCancelCandidateModuleMutation } from "../../../api/rtk/ExamSessionCandidateApi";

const MyExams: FC = () => {
  const history = useHistory();
  const {
    data: myModules,
    isFetching: isModulesFetching,
    refetch,
  } = useGetMyModulesAndExamsForCandidateQuery(undefined);
  const [cancelModuleForCandidate, { isLoading: isCancellingModule }] = useCancelCandidateModuleMutation();
  const isLoading = isModulesFetching || isCancellingModule;

  const [cancelDialogContext, setCancelDialogContext] = useState<CandidateMyModuleViewModel | undefined>(undefined);

  React.useEffect(() => {
    refetch();
  }, [refetch]);

  if (!isLoading && myModules === undefined) {
    return <></>;
  }

  const handleCancelModule = (module: CandidateMyModuleViewModel) => {
    setCancelDialogContext(module);
  };

  const onAcceptCancelModule = () => {
    const params = cancelDialogContext;
    setCancelDialogContext(undefined);
    if (params) {
      cancelModuleForCandidate({
        examSessionCandidateId: params.examSessionCandidateId,
        moduleId: params.moduleId,
        comments: undefined,
      });
    }
  };

  return (
    <HomeSection icon={<AssignmentIndIcon />} title={<TranslatedMessage id="home.myExams" />}>
      <Grid container spacing={2}>
        {isLoading && (
          <Grid item xs={12}>
            <LinearProgress variant="query" />
          </Grid>
        )}
        {!isLoading && (
          <>
            <Grid item>
              <Button
                variant="contained"
                size="small"
                color="primary"
                onClick={() => history.push(routesPaths.startCertification())}
              >
                <AddIcon />
                <TranslatedMessage id="home.myExams.newApplication" />
              </Button>
            </Grid>
            <Grid item xs={12}>
              {myModules && myModules.length ? (
                <MyExamsTable modules={myModules} onCancelModule={handleCancelModule} />
              ) : (
                <Typography>
                  <TranslatedMessage id="home.myExams.noExams" />
                </Typography>
              )}
            </Grid>
            <SelfCancelDialog
              isCancelDialogOpen={!!cancelDialogContext}
              onDecline={() => setCancelDialogContext(undefined)}
              onAccept={onAcceptCancelModule}
            />
          </>
        )}
      </Grid>
    </HomeSection>
  );
};

export default MyExams;
